import type { ApiClient } from 'clients/yogi-api'
import type { Account, AccountGroup } from 'features/accounts/types'

export type CreateAccountInput = {
  name: string
  salesforce_id: string
  account_group_uuid: string
}

export type CreateAccountGroupInput = {
  name: string
}

const ACCOUNTS_URL = '/client/accounts'
const ACCOUNT_GROUPS_URL = '/client/accounts/groups'

export class AccountsService {
  constructor(private client: ApiClient) {}

  async listAccounts(): Promise<Account[]> {
    const { data } = await this.client.get<{ accounts: Account[] }>(
      ACCOUNTS_URL,
    )
    return data.accounts
  }

  async listAccountGroups(): Promise<AccountGroup[]> {
    const { data } = await this.client.get<{ account_groups: AccountGroup[] }>(
      ACCOUNT_GROUPS_URL,
    )
    return data.account_groups
  }

  async createAccount(input: CreateAccountInput): Promise<Account> {
    const { data } = await this.client.post<{ account: Account }>(
      ACCOUNTS_URL,
      input,
    )
    return data.account
  }

  async createAccountGroup(
    input: CreateAccountGroupInput,
  ): Promise<AccountGroup> {
    const { data } = await this.client.post<{ account_group: AccountGroup }>(
      ACCOUNT_GROUPS_URL,
      input,
    )
    return data.account_group
  }
}
